interface Participant {
  rank: number;
  name: string;
  avatar: string;
  progress: string;
  isWinner?: boolean;
  walletAddress: string;
}

interface PodiumDisplayProps {
  first: Participant;
  second: Participant;
  third: Participant;
  onParticipantClick?: (walletAddress: string) => void;
}

export function PodiumDisplay({ first, second, third, onParticipantClick }: PodiumDisplayProps) {
  const getMedalColor = (rank: number) => {
    switch (rank) {
      case 1:
        return '#FFD700'; // Gold
      case 2:
        return '#C0C0C0'; // Silver
      case 3:
        return '#CD7F32'; // Bronze
      default:
        return '#FFFFFF';
    }
  };

  const getMedalBadgeStyle = (rank: number) => {
    if (rank === 1) {
      return 'bg-[#FFD700] text-[#0c1c0c]';
    } else if (rank === 2) {
      return 'bg-[#C0C0C0] text-[#0c1c0c]';
    } else {
      return 'bg-[#CD7F32] text-white';
    }
  };

  const PodiumItem = ({ participant, rank }: { participant: Participant; rank: number }) => {
    const isFirst = rank === 1;
    const avatarSize = isFirst ? 'size-20' : 'size-16';
    const medalColor = getMedalColor(rank);

    return (
      <div
        onClick={() => onParticipantClick?.(participant.walletAddress)}
        className={`flex flex-col items-center gap-2 w-1/3 ${onParticipantClick ? 'cursor-pointer active:scale-95 transition-transform' : ''}`}
      >
        <div className="relative">
          <img
            className={`${avatarSize} rounded-full object-cover border-4`}
            style={{ borderColor: medalColor }}
            src={participant.avatar}
            alt={`${participant.name} profile`}
          />
          <div className="absolute -bottom-2 w-full flex justify-center">
            <div className={`${getMedalBadgeStyle(rank)} rounded-full size-6 flex items-center justify-center text-xs font-bold`}>
              {rank}
            </div>
          </div>
        </div>
        <p className="font-bold text-white text-center text-sm mt-2">
          {participant.name}
        </p>
        <p className={`font-medium text-sm ${isFirst ? 'text-primary' : 'text-white/70'}`}>
          {participant.progress}
        </p>
      </div>
    );
  };

  return (
    <div className="flex justify-center items-end gap-2 pt-4">
      {/* 2nd place */}
      <PodiumItem participant={second} rank={2} />
      {/* 1st place */}
      <PodiumItem participant={first} rank={1} />
      {/* 3rd place */}
      <PodiumItem participant={third} rank={3} />
    </div>
  );
}
